import React, { useState } from "react";
// import yesIcon from "../../images/YES.svg";
// import noIcon from "../../images/NO.svg";
import { Grid, Typography } from "@material-ui/core";
import Draggable from "react-draggable";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import { isEmpty, range } from "lodash";
// import Draggable from "react-draggable";
// import "animate.css/animate.css";


const DropableLabel = (props) => {
  const {
    aref,
    title,
    inAnswer,
    getAnswers,
    currentAnswer,
    ifAnswer,
    classes,
    onDragOffEnd,
    onDragOffUpdate,
    name,
    dragStarted,
    setDragStarted,
    showAnimation,

    label,
    left,
    right,
    marginTop,
    rotate,
    isRight,
    isSubmitted,
    isCorrectLabel
  } = props;
  const [startLabel, setStartLabel] = useState("")
  const [bgColor, setBgColor] = useState("transparent")
  const [zIndex, setzIndex] = useState(2)
let borderColor = isSubmitted ? isCorrectLabel ? "green" : "red" : "#003e4c"
let borderStyle = isSubmitted ? "solid" : "dashed"

  return (
    <div ref={aref} style={{ position: 'relative', backgroundColor: inAnswer ? "#1db2d7" : "#fff", border: `2px ${borderColor} ${borderStyle}`, marginTop: marginTop, marginRight: right }} className={classes.DropableLabel}>
      {label ?
        <Draggable
        onDrag={onDragOffUpdate}
        onStart={() => { setzIndex(10); setBgColor("#fff"); setStartLabel(name) }}
        onStop={() => onDragOffEnd(label, name, startLabel)}
        position={{ x: 0, y: 0 }}
      >
        <Grid container className={classes.textContainer} style={{ backgroundColor: bgColor, zIndex: zIndex }}>
          <Typography className={classes.text} dangerouslySetInnerHTML={{__html: label }} />
        </Grid>
      </Draggable>
      : <div />
      }
      {/* <h4 className={classes.labelText} dangerouslySetInnerHTML={{__html: `${label}` ? `${label[0]}<sub>${label[1]}</sub>` : "" }}/> */}
  </div>
  );
};

export default withStyles(styles)(DropableLabel);
